import { DefaultErrorLogger as e } from "./default-error-logger.js";
import { ErrorLoggerInjectionFacade as g } from "../injection/error-logger-injection-facade.js";
class p {
  install(o) {
    const r = new e();
    return new g().provideToApp(r, o), r;
  }
}
export {
  p as ErrorLoggerPlugin
};
//# sourceMappingURL=error-logger-plugin.js.map
